module.exports = __webpack_public_path__ + "img/djembefolla.4f670673.png";